export const LONG_MOMENT_FORMAT = 'LL LTS'; // MMMM DD,YYYY HH:mm:ss
